import { App } from "vue";

import { ripple } from "../directives/ripple";
import { closePopup } from "../directives/closePopup";

// Import icon libraries
import "@fortawesome/fontawesome-pro/css/fontawesome.css";
import "@fortawesome/fontawesome-pro/css/light.css";
import "@fortawesome/fontawesome-pro/css/solid.css";
import "@fortawesome/fontawesome-pro/css/regular.css";

// ENG-20860 project-owned utility classes — must load BEFORE app.css so app.css
// overrides (e.g. .two-columns display:grid beating .flex) win, matching the
// original cascade where Quasar's utility bundle preceded app.css.
import "./../css/utilities.scss";

// overrides
import "./../css/app.css";

import { router } from "../router";
import { pinia } from "../store";

import { componentPlugin } from "./component";
import { globalPlugin } from "./global";
import { thirdPartyPlugins } from "./thirdparties";
import { tenantPlugin } from "./tenant";
import { updatePlugin } from "./update";
import { browserVersionPlugin } from "./browserVersion";
import { warningHandlerPlugin } from "./warningHandler";
import { nhsSigningService } from "./nhsSigningService";
import { labelPrintService } from "./labelPrintService";

export default (loadComponents = true) => ({
  install(app: App) {
    app.use(pinia);
    app.use(globalPlugin());
    if (loadComponents) {
      app.use(router);
    }

    // ENG-20861 in-house replacements for quasar's Ripple / ClosePopup directives
    app.directive("ripple", ripple);
    app.directive("close-popup", closePopup);

    if (loadComponents) {
      app.use(componentPlugin());
    }
    app.use(tenantPlugin());
    app.use(thirdPartyPlugins());

    if (IS_APP && !import.meta.env.DEV) {
      app.use(updatePlugin());
    }

    if (loadComponents) {
      app.use(browserVersionPlugin(router));
    }

    // only on dev and uat
    if (loadComponents && (import.meta.env.DEV || location.host.startsWith("uat."))) {
      app.use(warningHandlerPlugin());
    }

    app.use(nhsSigningService());
    app.use(labelPrintService());
  },
});
